import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const ContainerBlankVideo = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: black;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`;

export const TitleBlankVideo = styled(TextLayoutComponent)`
  color: white;
  font-size: 18px;
  margin: 30px 0;
  text-align: center;
`;
